import Model, { attr } from '@ember-data/model';

import type { Slack } from 'webapp-types';
import type { GoalStatus } from 'webapp/enums/enums';

export default class GoalLogRecord extends Model {
	@attr('number') goalId!: number;
	@attr('number') value!: number;
	@attr('string') valueStr!: string;
	@attr('string') message!: string | null;
	@attr('number') status!: GoalStatus;

	// Notifications
	@attr('boolean', { defaultValue: true }) isDeliveryOn!: boolean;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	delivery!: number[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	recipients!: string[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channel[];

	@attr('boolean') isPredefinedMessage!: boolean;
	@attr('number') created!: number; // Unix timestamp
	@attr('number') modified!: number; // Unix timestamp
	@attr('number') modifiedBy!: number;
	@attr('number') change!: number;
	@attr('string') changeStr!: string;
	@attr('number') createdBy!: number;
}
